module.exports = __webpack_public_path__ + "static/media/46_B.7053db5f.png";